import React, { Component } from 'react';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import * as repositoryActions from '../../Store/Actions/repositoryActions';

class Footer extends Component {
    // constructor(props) {
    //   super(props);
    //   // State is in reducers
    // }
  
    buildingFunction = ()=> {
      return [];
    }
  
  
  
    render() {
      // const someVar = this.buildingFunction(); 
  
      return (
        <div className="Footer">
          {/* <FontAwesomeIcon onClick={this.props.togglePresentationMode} icon={this.props.presentationMode?"compress-arrows-alt":"expand-arrows-alt"}/>
          <FontAwesomeIcon onClick={this.props.toggleNightMode} icon={this.props.nightMode?"lightbulb":"moon"}/> */}
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      presentationMode : state.appReducer.presentationMode,
      nightMode : state.appReducer.nightMode, 
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Footer);
  